import { render, staticRenderFns } from "./BankInfoPanel.vue?vue&type=template&id=b241390a&scoped=true"
import script from "./BankInfoPanel.vue?vue&type=script&lang=js"
export * from "./BankInfoPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b241390a",
  null
  
)

export default component.exports